import ERC20 from '../../models/ERC20';
export function parseERC20(result) {
    const erc20 = result.data.erc20;
    if (!erc20) {
        throw new Error('Unable to parse ERC20.');
    }
    return new ERC20(erc20);
}
//# sourceMappingURL=erc20s.js.map